import { registerSW as register } from "virtual:pwa-register";
import { toast } from "./components/ui/Toast";

export function registerSW() {
  const updateSW = register({
    onNeedRefresh() {
      toast.info("Update available", "Refresh to get the latest version.");
    },
    onOfflineReady() {
      toast.success(
        "Offline ready",
        "The app is cached and will work without an internet connection.",
      );
    },
  });

  // Expose update function globally for manual refresh
  (window as any).updateSW = updateSW;
}
